import { LuIcon } from "@overmap-ai/blocks"
import type { SortDirection } from "@tanstack/react-table"
import { memo } from "react"

import { tableIconMapping } from "../mappings"

interface ColumnSortIconProps {
	sortDirection: SortDirection | false
}

export const ColumnSortIcon = memo((props: ColumnSortIconProps) => {
	const { sortDirection } = props

	return (
		<LuIcon
			icon={
				sortDirection !== false
					? sortDirection === "asc"
						? tableIconMapping.ascSort
						: tableIconMapping.descSort
					: tableIconMapping.unsorted
			}
		/>
	)
})
ColumnSortIcon.displayName = "ColumnSortIcon"
